<template>
  <div
    v-if="isOpen"
    class="fixed inset-0 flex items-center justify-center z-50 rounded-[10px]"
  >
    <!-- Overlay -->
    <div
      class="fixed inset-0 bg-[#80808086] bg-opacity-50 rounded-[10px]"
      @click="closeModal"
    ></div>

    <!-- Modal -->
    <div
      class="relative bg-white w-[1000px] max-w-[90vw] rounded-[10px] shadow-lg z-10 flex flex-col max-h-[90vh]"
    >
      <!-- Header (sticky) -->
      <div
        class="bg-[#9A247B] text-white pl-[20px] py-[12px] pr-[10px] flex justify-between items-center rounded-t-[10px] sticky top-0 z-20"
      >
        <h3 class="s !text-[14px]">ประวัติการอัปเดตข้อมูลเหตุฉุกเฉิน</h3>
        <button
          @click="closeModal"
          class="text-white hover:text-gray-200 bg-white rounded-full"
        >
          <CloseIcon class="w-6 h-6 text-primary" />
        </button>
      </div>

      <!-- Body (scrollable) -->
      <div class="p-[20px] pt-[12px] overflow-y-auto overflow-x-hidden flex-1">
        <div class="pb-[10px]">
          <!-- ✅ ลำดับ/หน้าตาเดิมทุกอย่าง -->
          <SearchBox
            id="search1"
            placeholder="ค้นหา ชื่อผู้กระทำ"
            class="h-[42px] mb-[10px]"
            v-model="filters.search"
            @update:modelValue="onSearchChange"
          />
          <div class="flex gap-[10px] max-[481px]:flex-col">
            <DatePicker
              v-model="dateRange"
              :placeholder="'เลือกช่วงเวลาที่กระทำ'"
              :enbaleTimePicker="false"
              :min-date="null"
              :max-date="null"
              class="!w-[257px] max-[481px]:!w-full"
              range
              minDate=""
            />
            <!-- range -->
            <SelectBoxComponent
              :selectContainerClass="'w-full sm:max-w-[194px]'"
              :inputId="'team'"
              :isFilter="true"
              :searchable="true"
              :allowEmpty="true"
              :keyValue="'id'"
              :keyName="'name'"
              :options="[
                { id: '', name: 'แสดงทุกภัยพิบัติ' },
                { id: 1, name: 'อุทกภัย' },
                { id: 2, name: 'ดินถล่ม' },
                { id: 3, name: 'ไฟป่า' },
                { id: 4, name: 'หมอกควัน' },
                { id: 5, name: 'พายุฤดูร้อน' },
                { id: 6, name: 'แผ่นดินไหว' },
                { id: 7, name: 'อัคคีภัย' },
                { id: 8, name: 'โรคระบาด' },
              ]"
              :value="filters.disaster_id"
              :placeholder="'แสดงทุกภัยพิบัติ'"
              @update:modelValue="
                (res) => {
                  filters.disaster_id = res;
                  filters.page = '';
                  getHistory();
                }
              "
            />
            <SelectBoxComponent
              :selectContainerClass="'w-full sm:max-w-[141px]'"
              :inputId="'filterDistrictSelectorModal'"
              :isFilter="true"
              :searchable="true"
              :allowEmpty="true"
              :keyValue="'districtCode'"
              :keyName="'districtNameTh'"
              :value="filters.district_code"
              :placeholder="'แสดงทุกอำเภอ'"
              :provinceCode="57"
              @update:modelValue="
                (res) => {
                  filters.district_code = res;
                  filters.page = '';
                  getHistory();
                }
              "
            />
            <SelectBoxComponent
              :selectContainerClass="'w-full sm:max-w-[163px]'"
              :inputId="'action'"
              :isFilter="true"
              :keyValue="'id'"
              :keyName="'name'"
              :options="[
                { id: '', name: 'แสดงทุกการกระทำ' },
                { id: 1, name: 'ประกาศภัยพิบัติ' },
                { id: 2, name: 'อัปเดตภัยพิบัติ' },
                { id: 3, name: 'ยุติภัยพิบัติ' },
              ]"
              :value="filters.action"
              :placeholder="'แสดงทุกการกระทำ'"
              @update:modelValue="
                (res) => {
                  filters.action = res;
                  filters.page = '';
                  getHistory();
                }
              "
            />
          </div>
        </div>

        <!-- Table -->
        <div class="overflow-x-auto">
          <table class="min-w-full">
            <thead>
              <tr>
                <th
                  class="w-[92px] h-[53px] text-left px-[10px] py-[16px] bg-primary text-[#FFFFFF] rounded-tl-[6px] border-r border-[#FFFFFF] s !text-[14px]"
                >
                  วันที่กระทำ
                </th>
                <th
                  class="w-[54px] text-left px-[10px] py-[16px] bg-primary text-[#FFFFFF] border-r border-[#FFFFFF] s !text-[14px]"
                >
                  เวลา
                </th>
                <th
                  class="w-[544px] text-left px-[10px] py-[16px] bg-primary text-[#FFFFFF] border-r border-[#FFFFFF] s !text-[14px]"
                >
                  การกระทำ
                </th>
                <th
                  class="w-[270px] text-left px-[10px] py-[16px] bg-primary text-[#FFFFFF] rounded-tr-[6px] border-r border-[#FFFFFF] s !text-[14px]"
                >
                  ชื่อผู้กระทำ
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(row, index) in sheltersList"
                :key="index"
                class="h-[41px] s !text-[14px]"
                :class="[
                  '!border-none',
                  { 'bg-[#FBEFF8]': (index + 1) % 2 === 0 },
                ]"
              >
                <td
                  class="!border-none pl-[10px]"
                  :class="
                    index === sheltersList.length - 1 ? 'rounded-bl-[6px]' : ''
                  "
                >
                  {{ toThaiDate(row.created_at) }}
                </td>
                <td class="!border-none p-[10px]">
                  {{ toThaiTime(row.created_at) }}
                </td>
                <td class="!border-none p-[10px]">
                  {{ row.description }}
                </td>
                <td
                  class="!border-none p-[10px]"
                  :class="
                    index === sheltersList.length - 1 ? 'rounded-br-[6px]' : ''
                  "
                >
                  {{ row.created_by }}
                </td>
              </tr>
              <tr v-if="!sheltersList.length">
                <td colspan="4" class="text-center py-6 text-[#DFDCDD] text-sm">
                  ไม่พบข้อมูล
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <PaginationComponent
          class="mt-[10px]"
          :perPageId="'perpagemodal'"
          :items="items"
          @selectedPage="handlePage"
        />
      </div>
    </div>

    <!-- Sub-modal -->
    <ShelterInfoModal
      v-if="showShelterInfo"
      :shelter="shelterData"
      :manage="true"
      @close="showShelterInfo = false"
    />
  </div>
</template>

<script setup>
import { ref, watch, onBeforeUnmount, toRefs } from "vue";
import SearchBox from "@/components/Utilities/SearchBox.vue";
import ShelterInfoModal from "../Modals/ShelterInfoModal.vue";
import DatePicker from "@/components/Utilities/DatePicker.vue";
import { useDisaterRequestStore } from "@/pinia/disater";

// ---- props / emits ----
const props = defineProps({
  isOpen: { type: Boolean, default: false },
  data: { type: Array, default: () => [] },
});
const emit = defineEmits(["close", "page"]);
const { isOpen } = toRefs(props);

// ---- store ----
const DisaterRequestStore = useDisaterRequestStore();

// ---- filters ----
const filters = ref({
  search: "",
  start_date: null,
  end_date: null,
  disaster_id: null, // 2..9
  action: null, // 1=ประกาศ, 2=อัปเดต, 3=ยุติ
  district_code: null, // ถ้าต้องใช้ในอนาคต
  page: 1,
  pagination: 10,
});
const dateRange = ref(null);

// ---- mapping options (UI เดิม) ----
const OptionDisater = [
  "แสดงทุกภัยพิบัติ",
  "อุทกภัย",
  "ดินถล่ม",
  "ไฟป่า",
  "หมอกควัน",
  "พายุฤดูร้อน",
  "แผ่นดินไหว",
  "อัคคีภัย",
  "โรคระบาด",
];
const disasterNameToId = {
  อุทกภัย: 2,
  ดินถล่ม: 3,
  ไฟป่า: 4,
  หมอกควัน: 5,
  พายุฤดูร้อน: 6,
  แผ่นดินไหว: 7,
  อัคคีภัย: 8,
  โรคระบาด: 9,
};
const actionNameToId = { ประกาศ: 1, อัปเดต: 2, ยุติ: 3 };

// ---- data ----
const sheltersList = ref([]);
const items = ref(null);

const shelterData = ref({});
const showShelterInfo = ref(false);

// ---- UI helpers ----
function toThaiDate(iso) {
  if (!iso) return "-";
  const d = new Date(iso);
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear() + 543;
  return `${dd}-${mm}-${yyyy}`;
}
function toThaiTime(iso) {
  if (!iso) return "-";
  const d = new Date(iso);
  const hh = String(d.getHours()).padStart(2, "0");
  const mi = String(d.getMinutes()).padStart(2, "0");
  return `${hh}:${mi}`;
}

// ---- build params ----
function buildParams() {
  const p = {
    paginate: filters.value.pagination,
    page: filters.value.page,
  };
  if (filters.value.search?.trim()) p.search = filters.value.search.trim();
  if (filters.value.start_date) p.start_date = filters.value.start_date;
  if (filters.value.end_date) p.end_date = filters.value.end_date;
  if (filters.value.disaster_id) p.disaster_id = filters.value.disaster_id;
  if (filters.value.action) p.action = filters.value.action;
  if (filters.value.district_code)
    p.district_code = filters.value.district_code;
  return p;
}

// ---- API ----
async function getHistory() {
  try {
    const params = buildParams();
    const s = await DisaterRequestStore.getDisaterLog(params);
    sheltersList.value = Array.isArray(s?.data.data) ? s.data.data : [];
    items.value = s.data;
  } catch (e) {
    console.error("getHistory error:", e);
    sheltersList.value = [];
    // items.value = {
    //     current_page: 1,
    //     last_page: 1,
    //     from_page: 0,
    //     to_page: 0,
    //     per_page: filters.value.pagination,
    //     total: 0,
    // }
  }
}

// ---- events (ไม่เปลี่ยน UI, แค่ยิงอัตโนมัติ) ----
let searchDebounce;
function onSearchChange(val) {
  clearTimeout(searchDebounce);
  searchDebounce = setTimeout(() => {
    filters.value.page = 1;
    getHistory();
  }, 350); // debounce เบาๆ
}

watch(dateRange, (val) => {
  if (Array.isArray(val) && val.length === 2) {
    const [startISO, endISO] = val;
    filters.value.start_date = startISO || null;
    filters.value.end_date = endISO || null;
  } else {
    filters.value.start_date = null;
    filters.value.end_date = null;
  }
  // เปลี่ยนช่วงเวลา → ยิงใหม่
  filters.value.page = 1;
  getHistory();
});

// ---- pagination ----
function handlePage(page, perpage) {
  filters.value.page = page;
  filters.value.pagination = perpage;
  getHistory();
  emit("page", page);
}

// ---- open/close side effects ----
watch(isOpen, (val) => {
  document.body.style.overflow = val ? "hidden" : "";
  if (val) {
    // เปิดครั้งไหนก็โหลดตามฟิลเตอร์ปัจจุบัน
    getHistory();
  }
});
onBeforeUnmount(() => {
  document.body.style.overflow = "";
});

// ---- modal close ----
function closeModal() {
  emit("close");
  filters.value = {
    search: "",
    start_date: null,
    end_date: null,
    disaster_id: null, // 2..9
    action: null, // 1=ประกาศ, 2=อัปเดต, 3=ยุติ
    district_code: null, // ถ้าต้องใช้ในอนาคต
    page: 1,
    pagination: 10,
  };
}
</script>
